<template>
  <div class="express-checkout-container">
    <div id="express-checkout-element">
      <!-- Express Checkout Element will be mounted here -->
    </div>
    <div class="mb-2" v-if="isLoading">
      <Spinner size="small" color="dark" />
    </div>
  </div>
</template>

<script>
import Spinner from "../preloaders/Spinner";

export default {
  name: 'ExpressCheckoutElement',
  components: { Spinner },
  props: {
    stripe: {
      type: Object,
      required: false,
      default: null
    },
    elements: {
      type: Object,
      required: false,
      default: null
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    currency: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      expressCheckoutElement: null
    };
  },
  async mounted() {
    await this.initExpressCheckout();
  },
  beforeDestroy() {
    if (this.expressCheckoutElement) {
      this.expressCheckoutElement.destroy();
    }
  },
  methods: {
    async initExpressCheckout() {
      if (!this.elements || !this.stripe) {
        console.warn('Stripe or elements not initialized yet');
        return false;
      }

      // create Express Checkout Element with only Google Pay enabled
      this.expressCheckoutElement = this.elements.create('expressCheckout', {
        paymentMethods: {
          googlePay: 'always',
          link: 'never',
          applePay: 'never',
          amazonPay: 'never',
          paypal: 'never',
          klarna: 'never',
        },
        buttonTheme: {
          googlePay: 'black'
        },
        buttonType: {
          googlePay: 'buy'
        },
        layout: {
          overflow: 'never'
        },
        shippingRates: [
          {
            id: 'free',
            displayName: this.$t("payment.free_shipping"),
            amount: 0
          }
        ],
        shippingAddressRequired: true,
        billingAddressRequired: true,
        emailRequired: true,
        phoneNumberRequired: true,
        buttonHeight: 55
      });

      // mount the element
      this.expressCheckoutElement.mount('#express-checkout-element');

      // handle click event - validate before allowing popup
      this.expressCheckoutElement.on('click', (event) => {
        this.$emit('click', event);
      });

      // handle confirm event - create payment intent here
      this.expressCheckoutElement.on('confirm', async (event) => {
        this.$emit('confirm', event);
      });

      // handle shipping address change - this enables shipping collection
      this.expressCheckoutElement.on('shippingaddresschange', (event) => {
        event.resolve({
          shippingRates: [
            {
              id: 'free',
              displayName: this.$t("payment.free_shipping"),
              amount: 0
            }
          ]
        });
      });

      // handle shipping rate change
      this.expressCheckoutElement.on('shippingratechange', (event) => {
        event.resolve();
      });

      // handle cancel/abort event when user closes Google Pay popup without confirming
      this.expressCheckoutElement.on('cancel', () => {
        this.$emit('cancel');
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.express-checkout-container {
  margin-bottom: 20px;

  #express-checkout-element {
    /* Express Checkout Element styles will be handled by Stripe */
    min-height: 40px;
  }

  .mb-2 {
    margin-bottom: 0.5rem;
    text-align: center;
  }
}
</style>